import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../constants/baseUrl";

// CMS API slice
export const fileApi = createApi({
  reducerPath: "fileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: (file) => ({
        url: "/upload/image",
        method: "POST",
        body: file,
      }),
    }),
    uploadFile: builder.mutation({
      query: (file) => ({
        url: "/upload/file",
        method: "POST",
        body: file,
      }),
    }),
    downloadFile: builder.query({
      query: (fileId) => `/upload/download/${fileId}`,
    }),
    getFileById: builder.query({
      query: (fileId) => `/upload/file/${fileId}`,
    }),
  }),
});

export const {
  useGetFileByIdQuery,
  useUploadImageMutation,
  useUploadFileMutation,
  useDownloadFileQuery,
} = fileApi;
